/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { RegistryImageSearch200ResponseCounts } from './RegistryImageSearch200ResponseCounts'
import {
  RegistryImageSearch200ResponseCountsFromJSON,
  RegistryImageSearch200ResponseCountsFromJSONTyped,
  RegistryImageSearch200ResponseCountsToJSON,
} from './RegistryImageSearch200ResponseCounts'
import type { RegistryImageSearch200ResponsePagination } from './RegistryImageSearch200ResponsePagination'
import {
  RegistryImageSearch200ResponsePaginationFromJSON,
  RegistryImageSearch200ResponsePaginationFromJSONTyped,
  RegistryImageSearch200ResponsePaginationToJSON,
} from './RegistryImageSearch200ResponsePagination'
import type { RegistryImageSearch200ResponseData } from './RegistryImageSearch200ResponseData'
import {
  RegistryImageSearch200ResponseDataFromJSON,
  RegistryImageSearch200ResponseDataFromJSONTyped,
  RegistryImageSearch200ResponseDataToJSON,
} from './RegistryImageSearch200ResponseData'

/**
 *
 * @export
 * @interface RegistryImageSearch200Response
 */
export interface RegistryImageSearch200Response {
  /**
   *
   * @type {boolean}
   * @memberof RegistryImageSearch200Response
   */
  status: boolean
  /**
   *
   * @type {RegistryImageSearch200ResponseData}
   * @memberof RegistryImageSearch200Response
   */
  data: RegistryImageSearch200ResponseData
  /**
   *
   * @type {RegistryImageSearch200ResponseCounts}
   * @memberof RegistryImageSearch200Response
   */
  counts?: RegistryImageSearch200ResponseCounts
  /**
   *
   * @type {RegistryImageSearch200ResponsePagination}
   * @memberof RegistryImageSearch200Response
   */
  pagination?: RegistryImageSearch200ResponsePagination
}

/**
 * Check if a given object implements the RegistryImageSearch200Response interface.
 */
export function instanceOfRegistryImageSearch200Response(
  value: object
): value is RegistryImageSearch200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function RegistryImageSearch200ResponseFromJSON(
  json: any
): RegistryImageSearch200Response {
  return RegistryImageSearch200ResponseFromJSONTyped(json, false)
}

export function RegistryImageSearch200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): RegistryImageSearch200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: RegistryImageSearch200ResponseDataFromJSON(json['data']),
    counts:
      json['counts'] == null
        ? undefined
        : RegistryImageSearch200ResponseCountsFromJSON(json['counts']),
    pagination:
      json['pagination'] == null
        ? undefined
        : RegistryImageSearch200ResponsePaginationFromJSON(json['pagination']),
  }
}

export function RegistryImageSearch200ResponseToJSON(
  value?: RegistryImageSearch200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: RegistryImageSearch200ResponseDataToJSON(value['data']),
    counts: RegistryImageSearch200ResponseCountsToJSON(value['counts']),
    pagination: RegistryImageSearch200ResponsePaginationToJSON(
      value['pagination']
    ),
  }
}
